import Card from 'react-bootstrap/Card';

import { BiTimeFive } from 'react-icons/bi'
import { TiArrowForward } from 'react-icons/ti'

import './ArticleItem.css'
import { Link } from 'react-router-dom';

// we use props here for information become a dynamic info.
function ArticleItem({image , title , description , writter , readingTime , id}) {
    return(
          <Card>
            <Card.Img variant="top" src={image} />
            <Card.Body>
                <Card.Title className='py-2'>{title}</Card.Title>
                <Card.Text>
                    {description}
                </Card.Text>
                {/* here get id for that when clicked on the Read more : go to the new page for edit or remove the article.  */}
               <Link to={`/article/${id}`}>
                    <span className='read-more'>
                        <span>Read more :</span>
                        <TiArrowForward className='read-more-icon' size='30px' />
                    </span>
               </Link>
            </Card.Body>
            <Card.Footer className='d-flex justify-content-between align-items-center py-3'>
                <span>Author : {writter} </span>
                <span>{readingTime}m <BiTimeFive /> </span>
            </Card.Footer>
        </Card>
    )
}

export default ArticleItem